import styled from 'styled-components';

import Link from 'components/Link';

interface ButtonProps {
  $color: string | null;
  $justify?: string | null;
  to?: string;
  target?: string;
}

const ColorableButton = styled(Link)<ButtonProps>`
  border: 0.1rem solid ${(props) => (props.$color ? props.$color : props.theme.colors.white)};
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  text-align: center;
  text-transform: uppercase;
  border-radius: 5rem;
  align-items: center;
  padding: 0.45rem 1.5rem;
  font-size: 0.9rem;
  font-family: ${(props) => props.theme.fonts.default};
  font-weight: 600;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  background-color: ${(props) => (props.$color ? props.$color : 'rgba(0, 0, 0, 0)')};
  color: ${(props) => props.theme.colors.white};
  align-self: center;
  justify-self: ${(props) => (props.$justify ? props.$justify : 'stretch')};

  &:hover {
    background-color: ${(props) => (props.$color ? `${props.$color}D0` : props.theme.colors.white)};
    color: ${(props) => (props.$color ? props.theme.colors.white : props.theme.colors.black)};
    border: 0.1rem solid ${(props) => (props.$color ? `${props.$color}D0` : props.theme.colors.white)};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
    justify-self: stretch;
  }
`;

export default ColorableButton;
